import { render } from "./IconDiscord.vue?vue&type=template&id=7746f0ab"
import script from "./IconDiscord.vue?vue&type=script&lang=js"
export * from "./IconDiscord.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__